import { render } from "./edit.vue?vue&type=template&id=18c1c3b4"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=18c1c3b4&lang=css"
script.render = render

export default script